import(/* webpackMode: "eager" */ "/home/meywd/AlUmmahNow/node_modules/next/dist/client/app-dir/link.js");
